import { render } from "./SaleProductsPicker.vue?vue&type=template&id=93d94a38&scoped=true"
import script from "./SaleProductsPicker.vue?vue&type=script&lang=js"
export * from "./SaleProductsPicker.vue?vue&type=script&lang=js"

import "./SaleProductsPicker.vue?vue&type=style&index=0&id=93d94a38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d94a38"]])

export default __exports__